export const ISTRES_LOGO = "https://customer-assets.emergentagent.com/job_istres-commerce-hub/artifacts/yikb94se_unnamed-Photoroom.png";

export const ISTRES_CENTER = { lat: 43.5128, lng: 4.9889 };

export const ISTRES_PARKINGS = [
  { id: "p1", name: "Parking Place Champollion", lat: 43.5132, lng: 4.9897, capacity: 240, type: "Gratuit", hours: "24h/24" },
  { id: "p2", name: "Parking Hôtel de Ville", lat: 43.5125, lng: 4.9878, capacity: 180, type: "Payant", hours: "6h–22h" },
  { id: "p3", name: "Parking de l'Olivier", lat: 43.5148, lng: 4.9921, capacity: 350, type: "Gratuit", hours: "24h/24" },
  { id: "p4", name: "Parking Marché central", lat: 43.5119, lng: 4.9912, capacity: 120, type: "1h gratuite", hours: "7h–20h" },
  { id: "p5", name: "Parking Théâtre de l'Olivier", lat: 43.5102, lng: 4.9863, capacity: 200, type: "Gratuit", hours: "24h/24" },
];

/** Zones bleues — stationnement gratuit avec disque (durée limitée). */
export const ISTRES_ZONES_BLEUES = [
  { id: "zb1", name: "Zone bleue Place Champollion", lat: 43.5132, lng: 4.9897, radius: 70, duration: "1h30 max", hours: "Lun–Sam · 8h–19h", note: "Disque obligatoire" },
  { id: "zb2", name: "Zone bleue Hôtel de Ville", lat: 43.5125, lng: 4.9878, radius: 60, duration: "1h max", hours: "Lun–Sam · 9h–19h", note: "Disque obligatoire — gratuit" },
  { id: "zb3", name: "Zone bleue Bd Aristide Briand", lat: 43.5122, lng: 4.9892, radius: 80, duration: "1h30 max", hours: "Lun–Sam · 8h30–19h", note: "Disque obligatoire" },
  { id: "zb4", name: "Zone bleue rue Gambetta", lat: 43.5134, lng: 4.9886, radius: 55, duration: "30 min max", hours: "Lun–Sam · 8h–20h", note: "Rotation rapide commerces" },
  { id: "zb5", name: "Zone bleue Place de la République", lat: 43.5128, lng: 4.9895, radius: 60, duration: "1h max", hours: "Lun–Sam · 8h–19h", note: "Disque obligatoire" },
];

/** Dépose-minute — arrêts de courte durée (école, gare, mairie...). */
export const ISTRES_DEPOSE_MINUTE = [
  { id: "dm1", name: "Dépose-minute Mairie", lat: 43.5126, lng: 4.9876, max: "5 min", hours: "Lun–Ven · 8h–18h", note: "Devant l'Hôtel de Ville" },
  { id: "dm2", name: "Dépose-minute École Jean Jaurès", lat: 43.5115, lng: 4.9870, max: "5 min", hours: "Entrées/sorties scolaires", note: "Arrêt minute, moteur coupé" },
  { id: "dm3", name: "Dépose-minute Gare routière", lat: 43.5108, lng: 4.9905, max: "10 min", hours: "24h/24", note: "Voyageurs bus / TER" },
  { id: "dm4", name: "Dépose-minute Marché central", lat: 43.5119, lng: 4.9907, max: "5 min", hours: "Mar/Ven 7h–13h", note: "Dépôt rapide marché" },
  { id: "dm5", name: "Dépose-minute Pharmacie centrale", lat: 43.5128, lng: 4.9896, max: "5 min", hours: "Horaires pharmacie", note: "Arrêt minute" },
];

export const ISTRES_DELIVERY = [
  { id: "d1", name: "Livraison à vélo Istréen", lat: 43.5135, lng: 4.9881, zone: "Centre + 3 km", type: "velo" },
  { id: "d2", name: "Point Relais Place Hôtel de Ville", lat: 43.5126, lng: 4.9880, zone: "Retrait colis", type: "relais" },
  { id: "d3", name: "Drive Carrefour Istres", lat: 43.5078, lng: 4.9920, zone: "Drive", type: "drive" },
  { id: "d4", name: "Locker Pickup Place du Marché", lat: 43.5120, lng: 4.9908, zone: "Casiers 24/7", type: "locker" },
  { id: "d5", name: "Livraison à pied centre", lat: 43.5130, lng: 4.9890, zone: "Hyper-centre", type: "pied" },
];

/** Annuaire complet des commerçants — chaque entrée a coordonnées, horaires, PMR, livraison. */
export const ISTRES_COMMERCES = [
  {
    id: "c1", name: "Boulangerie du Soleil", cat: "Boulangerie",
    lat: 43.5130, lng: 4.9890,
    address: "12 Place Champollion, 13800 Istres",
    phone: "04 42 56 12 34",
    hours: "Lun–Sam · 6h30–19h30",
    pmr: true,
    delivery: "https://www.dispatch-deliveroo.fr/istres/boulangerie-du-soleil",
    parking_tip: "Parking Champollion (50m) — 1h gratuite",
    color: "#F59E0B",
  },
  {
    id: "c2", name: "Bijouterie Éclat", cat: "Bijouterie",
    lat: 43.5134, lng: 4.9885,
    address: "5 rue Gambetta, 13800 Istres",
    phone: "04 42 56 78 90",
    hours: "Mar–Sam · 9h30–12h, 14h–19h",
    pmr: true,
    delivery: null,
    parking_tip: "Parking Hôtel de Ville (80m)",
    color: "#7236CB",
  },
  {
    id: "c3", name: "Pharmacie Centrale", cat: "Pharmacie",
    lat: 43.5128, lng: 4.9895,
    address: "Place de la République, 13800 Istres",
    phone: "04 42 55 01 23",
    hours: "Lun–Sam · 8h30–19h30 · Dim de garde",
    pmr: true,
    delivery: "https://www.livmed-istres.fr",
    parking_tip: "Stationnement minute devant la pharmacie",
    color: "#16A34A",
  },
  {
    id: "c4", name: "Fleurs de Provence", cat: "Fleuriste",
    lat: 43.5125, lng: 4.9893,
    address: "18 Bd Aristide Briand, 13800 Istres",
    phone: "04 42 56 44 55",
    hours: "Mar–Sam · 9h–19h · Dim 9h–13h",
    pmr: false,
    delivery: "https://www.fleurs-istres.fr/livraison",
    parking_tip: "Parking Marché central (100m)",
    color: "#ED3F8B",
  },
  {
    id: "c5", name: "Café de la Place", cat: "Café-Restaurant",
    lat: 43.5131, lng: 4.9882,
    address: "Place Champollion, 13800 Istres",
    phone: "04 42 56 99 11",
    hours: "Tous les jours · 7h–23h",
    pmr: true,
    delivery: "https://www.ubereats.com/istres/cafe-de-la-place",
    parking_tip: "Parking Champollion (20m)",
    color: "#1E6FB8",
  },
  {
    id: "c6", name: "Librairie L'Olivier", cat: "Librairie",
    lat: 43.5136, lng: 4.9899,
    address: "9 rue Hélène Boucher, 13800 Istres",
    phone: "04 42 56 33 44",
    hours: "Mar–Sam · 10h–19h",
    pmr: true,
    delivery: "https://www.placedeslibraires.fr/librairie/lolivier-istres",
    parking_tip: "Parking Olivier (150m)",
    color: "#0F766E",
  },
];

/** Bornes d'information municipales. */
export const ISTRES_KIOSKS = [
  { id: "k1", name: "Office de tourisme", lat: 43.5127, lng: 4.9883, hours: "Lun–Sam · 9h–18h", type: "tourisme" },
  { id: "k2", name: "Borne info Hôtel de Ville", lat: 43.5125, lng: 4.9877, hours: "24h/24", type: "borne" },
  { id: "k3", name: "Point info Marché", lat: 43.5120, lng: 4.9909, hours: "Mar/Ven 7h–13h", type: "borne" },
];

/** Défibrillateurs accessibles au public (DAE). */
export const ISTRES_DEFIBRILLATORS = [
  { id: "dae1", name: "DAE Hôtel de Ville", lat: 43.5125, lng: 4.9879, access: "Hall d'accueil · 8h–18h" },
  { id: "dae2", name: "DAE Place Champollion", lat: 43.5131, lng: 4.9894, access: "Borne extérieure · 24h/24" },
  { id: "dae3", name: "DAE Théâtre de l'Olivier", lat: 43.5103, lng: 4.9864, access: "Foyer · pendant les spectacles" },
  { id: "dae4", name: "DAE Marché central", lat: 43.5120, lng: 4.9911, access: "Borne extérieure · 24h/24" },
];

/** Jours et lieux de marché. */
export const ISTRES_MARKETS = [
  { id: "m1", name: "Grand Marché provençal", day: "Mardi & Vendredi", hours: "7h–13h", lat: 43.5120, lng: 4.9908, where: "Place du Marché", desc: "Produits frais, artisanat, alimentation" },
  { id: "m2", name: "Marché Bio Istres", day: "Samedi", hours: "8h–13h", lat: 43.5131, lng: 4.9890, where: "Place Champollion", desc: "Producteurs locaux, agriculture biologique" },
  { id: "m3", name: "Marché aux puces", day: "1er dimanche du mois", hours: "8h–17h", lat: 43.5147, lng: 4.9920, where: "Parking de l'Olivier", desc: "Brocante, vide-grenier" },
];

/** Aires de jeux pour enfants & espaces publics ludiques (classés par âge). */
export const ISTRES_PLAYGROUNDS = [
  { id: "pl1", name: "Aire de jeux Parc de l'Olivier", lat: 43.5145, lng: 4.9925, ages: "3–10 ans", features: "Toboggans, balançoires, tyrolienne", access: "Ombragé · clôturé · bancs parents", free: true },
  { id: "pl2", name: "Square Champollion", lat: 43.5133, lng: 4.9899, ages: "2–6 ans", features: "Petits jeux à ressort, bac à sable", access: "Cœur de centre-ville · PMR", free: true },
  { id: "pl3", name: "Aire de jeux Plage de la Romaniquette", lat: 43.5008, lng: 4.9760, ages: "4–12 ans", features: "Structures bois, balançoires nid", access: "Près de la plage · parking gratuit", free: true },
  { id: "pl4", name: "Skate Park Istres", lat: 43.5085, lng: 4.9870, ages: "8 ans et +", features: "Bowl, modules street, rails", access: "Casque conseillé · accès libre", free: true },
  { id: "pl5", name: "City stade Mauran", lat: 43.5160, lng: 4.9942, ages: "10 ans et +", features: "Foot, basket, hand · grillagé", access: "Éclairé jusqu'à 22h · libre", free: true },
];

/** Clubs, équipements sportifs et associations sportives. */
export const ISTRES_SPORTS = [
  { id: "sp1", name: "Piscine municipale Aqualons", lat: 43.5095, lng: 4.9933, cat: "Piscine", ages: "Tous âges (dès 4 ans)", desc: "Bassin sportif 25m, pataugeoire, aqua-fitness", contact: "04 42 11 28 80" },
  { id: "sp2", name: "Stade Henri Magnan", lat: 43.5168, lng: 4.9968, cat: "Stade", ages: "Tous âges", desc: "Football, athlétisme · home du FC Istres", contact: "04 42 56 22 11" },
  { id: "sp3", name: "Tennis Club Istres", lat: 43.5072, lng: 4.9885, cat: "Tennis", ages: "Dès 5 ans", desc: "8 courts (4 couverts) · école de tennis", contact: "04 42 56 33 88" },
  { id: "sp4", name: "Salle d'escalade Vertigo", lat: 43.5083, lng: 4.9852, cat: "Escalade", ages: "Dès 6 ans", desc: "Bloc + voies · cours enfants & ados", contact: "06 12 34 56 78" },
  { id: "sp5", name: "Dojo Arts Martiaux Istréens", lat: 43.5121, lng: 4.9850, cat: "Arts martiaux", ages: "5–18 ans + adultes", desc: "Judo, karaté, taekwondo", contact: "04 42 56 19 22" },
  { id: "sp6", name: "Club de voile Étang de l'Olivier", lat: 43.5165, lng: 4.9920, cat: "Voile", ages: "Dès 7 ans", desc: "Optimist, dériveur, planche · stages été", contact: "04 42 11 36 70" },
  { id: "sp7", name: "Centre équestre Les Cavaliers du Soleil", lat: 43.5028, lng: 5.0010, cat: "Équitation", ages: "Dès 4 ans (poneys)", desc: "Cours, balades, stages vacances", contact: "06 21 43 65 87" },
];

/** Animations, ateliers, sorties culturelles et événements récurrents. */
export const ISTRES_ANIMATIONS = [
  { id: "an1", name: "Médiathèque Istres", lat: 43.5117, lng: 4.9870, cat: "Culture", ages: "Tous âges", desc: "Heure du conte, ateliers créatifs, club ado", schedule: "Mer 15h, Sam 11h · gratuit" },
  { id: "an2", name: "Centre d'arts plastiques", lat: 43.5135, lng: 4.9920, cat: "Atelier", ages: "6–14 ans", desc: "Peinture, dessin, modelage", schedule: "Mer & Sam · inscription mairie" },
  { id: "an3", name: "Théâtre de l'Olivier", lat: 43.5103, lng: 4.9864, cat: "Spectacle", ages: "Programme tous publics", desc: "Saison spectacles, pièces jeune public", schedule: "Voir programmation" },
  { id: "an4", name: "Ludothèque municipale", lat: 43.5122, lng: 4.9885, cat: "Jeux", ages: "3–12 ans", desc: "Plus de 1500 jeux · jouer sur place ou emprunter", schedule: "Mer/Sam 14h–18h" },
  { id: "an5", name: "Cinéma Le Coluche", lat: 43.5128, lng: 4.9876, cat: "Cinéma", ages: "Tous âges", desc: "Films récents & ciné-club · tarifs jeunes", schedule: "Tous les jours" },
];

/** Vraies photos d'Istres — Wikimedia Commons (libres de droit). */
export const ISTRES_PHOTOS = [
  {
    src: "https://upload.wikimedia.org/wikipedia/commons/thumb/f/fb/Berges_Olivier_Istres.jpg/1280px-Berges_Olivier_Istres.jpg",
    label: "Étang de l'Olivier", caption: "Berges de l'étang de l'Olivier", credit: "Wikimedia Commons",
  },
  {
    src: "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3d/Istres_-_Centre_ancien.jpg/1024px-Istres_-_Centre_ancien.jpg",
    label: "Centre historique", caption: "Le centre ancien d'Istres", credit: "Wikimedia Commons",
  },
  {
    src: "https://upload.wikimedia.org/wikipedia/commons/thumb/4/41/Tour_Eglise_Notre-Dame_de_Beauvoir_istres.jpg/800px-Tour_Eglise_Notre-Dame_de_Beauvoir_istres.jpg",
    label: "Patrimoine", caption: "Notre-Dame de Beauvoir", credit: "Wikimedia Commons",
  },
  {
    src: "https://upload.wikimedia.org/wikipedia/commons/thumb/3/31/Port_d%27Istres_les_Heures_Claires.jpg/1024px-Port_d%27Istres_les_Heures_Claires.jpg",
    label: "Port", caption: "Port des Heures Claires", credit: "Wikimedia Commons",
  },
];

/** Helper pour ouvrir un itinéraire (Google Maps web) vers une coord. */
export function itineraryUrl(lat, lng, label = "") {
  const q = label ? `${encodeURIComponent(label)}@${lat},${lng}` : `${lat},${lng}`;
  return `https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}&travelmode=walking&destination_place_id=${encodeURIComponent(label)}`;
}
